import { render, staticRenderFns } from "./addPemilikSaham.vue?vue&type=template&id=6715c7eb&scoped=true&"
import script from "./addPemilikSaham.vue?vue&type=script&lang=js&"
export * from "./addPemilikSaham.vue?vue&type=script&lang=js&"
import style0 from "./addPemilikSaham.vue?vue&type=style&index=0&id=6715c7eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6715c7eb",
  null
  
)

export default component.exports